import { createAsyncThunk } from '@reduxjs/toolkit';

import { trackProgressionEventThunk } from '../../../../learn/slices/progress/thunks/track-progression-event.thunk.ts';
import { TrackingEventEnum } from '../../../../main/constants/tracking-event.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';

import { getFeedbackManagerUtil } from '../../../utils/feedback-manager.util.ts';

import { FEEDBACK_SLICE_NAME } from '../feedback.slice.types.ts';

interface Props {
  event: TrackingEventEnum.FEEDBACK_PROVIDED_GENERAL | TrackingEventEnum.FEEDBACK_PROVIDED_LESSON_END;
  questions: string[];
  responses: string[];
}

const THUNK_NAME = `${FEEDBACK_SLICE_NAME}/sendFeedback`;

export const sendFeedbackThunk = createAsyncThunk<void, Props, ThunkApiConfigType>(THUNK_NAME, (props, thunkAPI) => {
  const { event, questions, responses } = props;

  const feedbackManagerUtil = getFeedbackManagerUtil();
  const feedback = feedbackManagerUtil.mergeQuestionsAndResponses(questions, responses);

  thunkAPI.dispatch(trackProgressionEventThunk({ event, feedback }));
});
